import React from 'react';
import PropTypes from 'prop-types';

import { Stats } from './SectionStats.styled';

const SectionStats = ({ dark, isHome, customCSS }) => (
  <Stats dark={dark} isHome={isHome} css={customCSS}>
    <div className="container">
      <div className="d-block d-md-flex justify-content-between align-items-center">
        <div className="d-block d-md-flex align-items-center flex-wrap flex-lg-nowrap p-md-0 py-3">
          <div className="statistic-number">
            <h4>255+</h4>
          </div>
          <div className="statistic-description">
            <p>
              Projects
              <br />
              delivered
            </p>
          </div>
        </div>
        <div className="d-block d-md-flex align-items-center flex-wrap flex-lg-nowrap p-md-0 py-3">
          <div className="statistic-number">
            <h4>125+</h4>
          </div>
          <div className="statistic-description">
            <p>
              Clients Served
              <br />
              by our team
            </p>
          </div>
        </div>
        <div className="d-block d-md-flex align-items-center flex-wrap flex-lg-nowrap p-md-0 py-3">
          <div className="statistic-number">
            <h4 className="d-none d-md-block">1500+</h4>
            <h4 className="d-block d-md-none">1k+</h4>
          </div>
          <div className="statistic-description">
            <p>
              Talented
              <br />
              Resources hired
            </p>
          </div>
        </div>
      </div>
    </div>
  </Stats>
);

SectionStats.propTypes = {
  dark: PropTypes.bool,
  isHome: PropTypes.bool,
  customCSS: PropTypes.string,
};

export default SectionStats;
